
// Debug State:
const debugBDKalk = false //  <-- To switch debug mode on or off, just change the debugBDKalk to true (debug on) or false (off) : if on, then eventual assertion errors will pop up

// Debug state check
export function IsDebuging() {
    return PADebug.IsDebuging()
}

// Assert shows a popup message contining the provided text if debug mode is on and a condition is untrue
export function Assert(condition: boolean, errorDescriptionAndLocation: string) {
    return PADebug.Assert(condition, errorDescriptionAndLocation)
}

// Debug shows a popup message contining the provided text if debug mode is on
export function Debug(message: string) {
    PADebug.Debug(message)
}

// DebugOnce works just like the Debug method, but won't show the same message more than once
export function DebugOnce(message: string) {
    PADebug.DebugOnce(message)
}

// LogOnce works just like the Log method, but won't log the same message more than once
export function LogOnce(message: string) {
    PADebug.LogOnce(message)
}

// Log adds a message to the log, which can be seen while the program is run in debug mode and by using the log button on the toolbar
export function Log(logMessage: string) {
    PADebug.Log(logMessage)
}

// LogExpanded works like Log but lets you specify text color and ad tabs for displaying indented code in the log view
export function LogExpanded(tabs: number, logMessage: string, color: string) {
    PADebug.LogExpanded(tabs, logMessage, color)
}

// 
export function LogJson(rawJson: string, color?: string) {
    PADebug.LogJson(rawJson,color)
}

// 
export function GetLog() {
    return PADebug.GetLog()
}

// 
export function ResetLog() {
    PADebug.ResetLog()
}

///////////////   PADebug  ////////////////

// PriceBook holds all the data and info about a price book
export class PADebugKit {
 
    constructor() {
        this.m_debugPlaces = new Array<{ message: string, times: number }>()
        this.m_log = new Array<{ message: string, meta: number, tabs:number, color:string }>()
    }
    
    // Debug state check
    public IsDebuging() {
        if (debugBDKalk) {
            return true
        }
        else {
            return false
        }
    }

    // Assert shows a popup message contining the provided text if debug mode is on and a checked condition is false
    public Assert(condition: boolean, errorDescriptionAndLocation: string) {
        if (debugBDKalk) {
            if (condition == false) {
                this.m_log.push({ message: errorDescriptionAndLocation, meta: 2, tabs:0, color:"red" })
                alert("ASSERTION FAILED: " + errorDescriptionAndLocation)
            }
        }
    }

    // Debug causes the provided string parameter to be shown as a popup message during runtime, but only if the
    // program is run in debug mode, otherwise nothing will happen.
    Debug(message: string) {
        if (PADebug.IsDebuging() == false) {
            return // This alert should only take place when in debug mode
        }

        this.m_log.push({ message: message, meta: 1, tabs:0, color:"blue" })
        alert("Debug: " + message)
    }
    
    // DebugOnce shows a popup message contining the provided text if debug mode is on, but this popup window will not come
    // up more than once if the same identical string is used again later.
    DebugOnce(message: string) {

        if (PADebug.IsDebuging() == false) {
            // This alert should only take place when in debug mode
            return 
        }

        for (var i = 0; i < this.m_debugPlaces.length; i++) {
            if (this.m_debugPlaces[i].message == message) {
                this.m_debugPlaces[i].times++

                if (this.m_debugPlaces[i].times == 1001) {
                    PADebug.Debug(message + " (this message was repeated more than 1000 times.)")
                }

                // This alert has already been shown
                return 
            }
        }

        this.m_debugPlaces.push({ message: message, times: 1 })

        PADebug.Debug(message + " ")
    }

    // Log adds a string to the log string array if 
    Log(logMessage: string) {
        if (PADebug.IsDebuging() == true) {
            this.m_log.push({ message: logMessage, meta: 0, tabs: 0, color: "black" })
        }
    }

    // LogOnce does not log any message more than once if the same identical string is used again later.
    LogOnce(message: string) {

        if (PADebug.IsDebuging() == false) {
            // This log should only take place when in debug mode
            return
        }

        for (var i = 0; i < this.m_debugPlaces.length; i++) {
            if (this.m_debugPlaces[i].message == message) {
                this.m_debugPlaces[i].times++

                if (this.m_debugPlaces[i].times == 1001) {
                    PADebug.Log(message + " (this message was repeated more than 1000 times.)")
                }

                // This message has already been logged
                return
            }
        }

        this.m_debugPlaces.push({ message: message, times: 1 })

        PADebug.Log( message )
    }

    LogExpanded(tabs: number, logMessage: string, color: string) {
        if (PADebug.IsDebuging() == true) {
            this.m_log.push({ message: logMessage, meta: 0, tabs: tabs, color: color })
        }
    }

    LogJson(rawJson: string, color?:string) {
        var contents: Array<{ message: string, tabs: number }> = this.RawJsonToStringArray(rawJson)
        
        for (var r = 0; r < contents.length; r++) {
            PADebug.LogExpanded(contents[r].tabs, contents[r].message, color?color:"black")
        }
    }

    GetLog() {
        return this.m_log
    }

    ResetLog() {
        this.m_log = new Array<{ message: string, meta: number, tabs: number, color: string }>()
        this.m_debugPlaces = new Array<{ message: string, times: number }>()
    }

    RawJsonToStringArray(data: string) {
        var result = new Array<{ message: string, tabs: number }>()
        var indent = 0
        var ii: number
        var currentRow: string = ""

        for (var i = 0; i < data.length; i++) {
            if (data.charAt(i) == "{") {
                currentRow += "{"
                result.push({ message: currentRow, tabs: indent })
                currentRow = ""
                indent++
                continue
            }

            if (data.charAt(i) == "}") {
                if ((i + 1) < data.length) {
                    if (data.charAt(i + 1) == ",") {
                        result.push({ message: currentRow, tabs: indent })
                        indent--
                        result.push({ message: "},", tabs: indent })
                        currentRow = ""
                        i++
                        continue
                    }
                }

                if (currentRow != "") {
                    result.push({ message: currentRow, tabs: indent })
                }

                indent--
                result.push({ message: "}", tabs: indent })
                currentRow = ""
                continue
            }

            if (data.charAt(i) == "[") {
                currentRow += "["
                result.push({ message: currentRow, tabs: indent })
                currentRow = ""
                indent++
                continue
            }

            if (data.charAt(i) == "]") {
                if ((i + 1) < data.length) {
                    if (data.charAt(i + 1) == ",") {
                        result.push({ message: currentRow, tabs: indent })
                        indent--
                        result.push({ message: "],", tabs: indent })
                        currentRow = ""
                        i++
                        continue
                    }
                }

                if (currentRow != "") {
                    result.push({ message: currentRow, tabs: indent })
                }
                    
                indent--
                result.push({ message: "]", tabs: indent })
                currentRow = ""
                continue
            }

            if (data.charAt(i) == ",") {
                currentRow += ","
                result.push({ message: currentRow, tabs: indent })
                currentRow = ""
                continue
            }

            currentRow += data.charAt(i)
        }

        return result
    }

    private m_debugPlaces: Array<{ message: string, times: number }> // Keeps track of debug messages which should only be shown once, so that they won't be shown again
    private m_log: Array<{ message: string, meta: number, tabs:number, color:string }> // Collection of log strings with meta sign from the Log and debug methods
    // Following are the types of log messages: 0:normal log  1:Debug message  2:Failed Assertion 
}

export const PADebug = new PADebugKit()


// WEBPACK FOOTER //
// ./client/view/PADebug.tsx